import { __awaiter } from 'tslib';
import * as JSONLong from 'json-long';
import 'long';
import { im_proto } from '../../proto/index.js';
import { InfoKeys } from '../../core/consts.js';
import { Logger } from '../../core/metrics/logger.js';
import '../../core/metrics/monitor.js';
import { ServiceIdentity } from '../../core/service/RuntimeContext.js';
import '../../core/network/NetworkItem.js';
import 'moize';
import '../../core/model/Message.js';
import 'js-md5';
import '../../core/utils/lz4.js';
import '../../core/utils/serializer.js';
import '../../adapter/manager/AdapterManager.js';
import '../../adapter/manager/types.js';
import '../../core/utils/ticker.js';
import '../../adapter/abstract/IMNetApi.js';
import '../../core/options.js';
import '../../core/utils/uuid.js';
import '../../core/service/ConversationManager.js';
import '../../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../../core/plugin/DbProxy.js';
import '../../core/metrics/trackerTypes.js';
import { BaseProcessor } from '../../core/service/processor/BaseProcessor.js';
import '../../core/model/CommandMessage.js';

class PinCmdProcessor extends BaseProcessor {
    process(item) {
        return __awaiter(this, void 0, void 0, function* () {
            if (item.data.type === im_proto.MessageType.MESSAGE_TYPE_MARK_COMMAND) {
                item.needContinue = false;
                this.handlePinCmd(item.data, item.conv);
            }
            else if (item.data.type === im_proto.MessageType.MESSAGE_TYPE_BATCH_UNMARK_COMMAND) {
                item.needContinue = false;
                this.handleBatchUnmarkCmd(item.data, item.conv);
            }
            return item;
        });
    }
    handlePinCmd(message, conversation) {
        const content = JSONLong.parse(message.content);
        const messageId = content.server_message_id.toString(); // update ext 要用 server id 查消息
        const localMsg = this.resolve(ServiceIdentity.MessageManager).getByServerIdRaw(conversation.id, messageId);
        if (!localMsg) {
            Logger.ctxWarn(this.ctx, 'local message not exist, serverMsg=', message);
            return;
        }
        if (localMsg.version.gt(message.version)) { // 改成 gt, 丢掉旧消息
            Logger.ctxWarn(this.ctx, 'server message is older, localMsg=', localMsg, 'serverMsg=', message);
            return;
        }
        localMsg.ext = message.ext;
        localMsg.version = message.version; // 更新版本号, 可能被多次修改
        this.resolve(ServiceIdentity.MessageManager).upsert(localMsg);
    }
    handleBatchUnmarkCmd(message, conversation) {
        var _a, _b;
        const toUpdateMessage = JSONLong.parse((_b = (_a = message === null || message === void 0 ? void 0 : message.ext) === null || _a === void 0 ? void 0 : _a[InfoKeys.MarkMessageNewExt]) !== null && _b !== void 0 ? _b : '{}'); // TODO: type
        for (const item of Object.keys(toUpdateMessage)) {
            const localMsg = this.resolve(ServiceIdentity.MessageManager).getByServerIdRaw(conversation.id, item.toString());
            if (!localMsg) {
                Logger.ctxWarn(this.ctx, 'local message not exist, serverMsg=', message);
                continue;
            }
            localMsg.ext = Object.assign(localMsg.ext, toUpdateMessage[item]);
            localMsg.version = message.version; // 更新版本号, 可能被多次修改
            this.resolve(ServiceIdentity.MessageManager).upsert(localMsg);
        }
    }
}

export { PinCmdProcessor };
//# sourceMappingURL=PinCmdProcessor.js.map
